import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'

import { Roles } from '../../config'
import { editCompanyUsers, fetchUsers } from '../../actions'
import Loading from '../Loading'

import { Form, Input, Button, Select } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

const roleFormItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 6 }
}

class AppSettingsCompanyUsers extends Component {
  state = {
    selectedCompanyUsers: (this.props.company && _.keys(this.props.company.users)) || null
  }

  componentDidMount = () => {
    const { user, fetchUsers } = this.props

    if (user.isSuperAdmin) {
      fetchUsers()
    }
  }

  handleUsersChange = values => {
    this.setState({ selectedCompanyUsers: [...values] })
  }

  handleSubmit = e => {
    e.preventDefault()
    const {
      match: { params },
      form,
      editCompanyUsers
    } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        editCompanyUsers(params.companyId, values.users)
      } else {
        console.log(err)
      }
    })
  }

  // removeUser = userId => {
  //   const { selectedCompanyUsers } = this.state

  //   const userIndex = selectedCompanyUsers.indexOf(userId)

  //   this.setState({
  //     selectedCompanyUsers: selectedCompanyUsers.filter((_, i) => i !== userIndex)
  //   })
  // }

  render () {
    const {
      t,
      form: { getFieldDecorator },
      loading,
      user,
      users,
      company
    } = this.props
    const { selectedCompanyUsers } = this.state

    let availableUsers = null
    if (user.isSuperAdmin) {
      if (!users || loading.fetchUsers) return <Loading />
      availableUsers = users
    } else {
      availableUsers = company.users
    }

    // generate users Options - for multi Select field
    const usersOptions = []
    _.map(availableUsers, (userData, userId) =>
      usersOptions.push(
        <Option key={userId} value={userId} title={userData.name || userData.name_sync}>
          {userData.name || userData.name_sync}
        </Option>
      )
    )
    // generate roles Options - used for selecting role for each of selected users
    const companyRolesOptions = []
    _.map(Roles.COMPANY, (role, roleKey) =>
      companyRolesOptions.push(
        <Option key={role} value={role}>
          {t(`roles.${roleKey}`)}
        </Option>
      )
    )

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          {/* show 'users' Select only to SA, Company Admin can only change their roles */}
          {/* {user.isSuperAdmin && */}
          <FormItem label='Select Users'>
            {getFieldDecorator('userIds', {
              initialValue: (company && _.keys(company.users)) || null
            })(
              <Select
                mode='multiple'
                optionFilterProp='title'
                placeholder='Select Company users'
                onChange={this.handleUsersChange}
              >
                {usersOptions}
              </Select>
            )}
          </FormItem>
          {/* } */}

          {selectedCompanyUsers &&
            selectedCompanyUsers.map(userId => [
              // we want to edit only Company users' roles here, but we will use this invisible Input for user's 'name_sync',
              // otherwise we will need to do difference between previous and current 'selectedCompanyUsers' array etc.
              // - this way we'll send whole 'users' object to Firebase, not only user roles
              <FormItem key={userId + '_name_sync'} style={{ display: 'none' }}>
                {getFieldDecorator(`users.${userId}.name_sync`, {
                  initialValue: availableUsers[userId].name || availableUsers[userId].name_sync,
                  rules: [{ required: true, message: 'Company user name_sync is required' }]
                })(<Input disabled />)}
              </FormItem>,

              <FormItem
                label={
                  availableUsers[userId] ? availableUsers[userId].name || availableUsers[userId].name_sync : userId
                }
                key={userId}
                {...roleFormItemLayout}
              >
                {getFieldDecorator(`users.${userId}.role`, {
                  initialValue: (company.users && company.users[userId] && company.users[userId].role) || undefined,
                  rules: [{ required: true, message: 'Company user role is required' }]
                })(
                  <Select placeholder='Company role' style={{ width: 150 }}>
                    {companyRolesOptions}
                  </Select>
                )}

                {/* {!user.isSuperAdmin &&
                  <Icon
                    type='close'
                    onClick={() => this.removeUser(userId)}
                    style={{ cursor: 'pointer', marginLeft: 10 }}
                    key='button-delete'
                  />} */}
              </FormItem>
            ])}

          <FormItem>
            <Button htmlType='submit' type='primary' loading={loading.editCompanyUsers}>
              Save
            </Button>
          </FormItem>
        </Form>
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading,
  user: state.user,
  users: state.users
})

const mapDispatchToProps = {
  editCompanyUsers,
  fetchUsers
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(withRouter(translate('translations')(AppSettingsCompanyUsers))))



// WEBPACK FOOTER //
// ./src/components/AppSettings/AppSettingsCompanyUsers.js